import { createFileRoute } from '@tanstack/react-router';
import GhostPage from '../../../pages/lineups/GhostPage';

export const Route = createFileRoute('/_authenticated/$owner/ghost')({
  component: RouteComponent
});

function RouteComponent() {
  return <GhostPage />;
}
